function buildUrl(baseUrl: string, path: string = ''): string {
  baseUrl = baseUrl
    .trim()
    .replace(/^['"]|['"]$/g, '')
    .replace(/\/+$/, '');

  if (!path.startsWith('/')) {
    path = '/' + path;
  }

  return `${baseUrl}${path}`;
}

export function buildPetPassUrl(path: string = ''): string {
  return buildUrl(appEnv.PETPASSURL ?? '', path);
}

export function buildGlobalAdminUrl(path: string = ''): string {
  return buildUrl(appEnv.GLOBALADMINURL ?? '', path);
}
